import React from 'react';
import { motion } from 'framer-motion';
import { Zap, FileText, Clock, Award, ShieldCheck, Lock, CreditCard, ArrowRight, TrendingUp, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-4 pb-12 overflow-hidden" data-id="element-338">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-radial-glow pointer-events-none opacity-60" data-id="element-339"></div>
      <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-energy/5 blur-[120px] rounded-full pointer-events-none" data-id="element-340"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-341">
        {/* Announcement Bar */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex items-center justify-center mb-6" data-id="element-342">
          <div className="bg-petroleum/80 backdrop-blur-sm border border-electric/30 rounded-2xl py-3 px-8 md:px-16 flex flex-col items-center gap-1.5 text-xs md:text-sm w-full max-w-2xl" data-id="element-343">
            <span className="inline-flex items-center gap-1.5 bg-electric/15 text-electric font-semibold rounded-full px-2.5 py-0.5" data-id="element-344">
              <Zap className="w-3.5 h-3.5 fill-electric" data-id="element-345" />
              BIBLIOTECAS DIGITALES™
            </span>
            <span className="text-textsecondary" data-id="element-346">Facturá tus Primeros USD</span>
          </div>
        </motion.div>

        <div className="max-w-5xl mx-auto text-center" data-id="element-347">
          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="md:text-5xl lg:text-6xl font-extrabold mb-6 text-[33px] leading-tight" data-id="element-348">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric to-gold text-[25px]" data-id="element-349">
              MEGAPACK FREELANCER
            </span>
            <br data-id="element-350" />
            <span className="text-white text-[25px]" data-id="element-351">
              Facturá tus Primeros USD
            </span>
          </motion.h1>

          {/* Mockup + Floating CTA card + Floating Widgets */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="relative mb-6 max-w-[420px] sm:max-w-lg md:max-w-2xl mx-auto" data-id="element-352">
            <div className="absolute inset-0 bg-electric/20 blur-[100px] rounded-full" data-id="element-353"></div>

            <img src="https://cdn.magicpatterns.com/uploads/x9f2xspoDWP4NYnVbawmPg/MOCKUP_SF.png" alt="MEGAPACK FREELANCER" loading="eager" decoding="async" className="relative z-10 w-full block object-contain drop-shadow-2xl" data-id="element-354" />

            {/* Floating Widget 1 - Top Left (inside container edge) */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.6,
            duration: 0.5
          }} className="hidden md:flex absolute left-0 lg:-left-6 top-6 flex-col bg-petroleum/90 border border-electric/30 rounded-2xl shadow-2xl p-3.5 z-30 w-[160px] text-left" data-id="element-355">
              <span className="text-[10px] text-textsecondary uppercase tracking-wider font-bold mb-1" data-id="element-356">
                Ingresos del mes
              </span>
              <span className="text-energy font-extrabold text-xl mb-2 leading-none" data-id="element-357">
                USD 1.247
              </span>
              <svg width="100%" height="22" viewBox="0 0 80 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-2" aria-hidden="true" data-id="element-358">
                <path d="M2 22L20 14L35 18L55 6L78 2" stroke="#00E676" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-359" />
              </svg>
              <div className="flex items-center gap-1 text-energy text-xs font-bold" data-id="element-360">
                <TrendingUp className="w-3.5 h-3.5" data-id="element-361" />
                <span data-id="element-362">+42%</span>
              </div>
            </motion.div>

            {/* Floating Widget 2 - Middle Right (inside container edge) */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.8,
            duration: 0.5
          }} className="hidden md:flex absolute right-0 lg:-right-6 top-1/2 -translate-y-1/2 flex-col bg-petroleum/90 border border-electric/30 rounded-2xl shadow-2xl p-3.5 z-30 w-[180px] text-left" data-id="element-363">
              <div className="flex items-center gap-2.5 mb-2" data-id="element-364">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-electric to-golddark flex items-center justify-center text-graphite font-bold text-xs flex-shrink-0" data-id="element-365">
                  NC
                </div>
                <span className="text-white font-semibold text-sm" data-id="element-366">
                  Nuevo cliente
                </span>
              </div>
              <div className="text-energy text-xs font-bold mb-2" data-id="element-367">
                Pago confirmado · USD 350
              </div>
              <div className="flex items-center gap-1.5" data-id="element-368">
                <div className="w-1.5 h-1.5 rounded-full bg-energy" data-id="element-369"></div>
                <span className="text-textsecondary text-[10px]" data-id="element-370">
                  Hace 2 min
                </span>
              </div>
            </motion.div>

            {/* Floating Widget 3 - Bottom Left (inside container edge) */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 1.0,
            duration: 0.5
          }} className="hidden md:flex absolute left-0 lg:-left-4 bottom-20 flex-col bg-petroleum/90 border border-electric/30 rounded-2xl shadow-2xl p-3.5 z-30 w-[170px] text-left" data-id="element-371">
              <div className="flex gap-0.5 mb-1.5" data-id="element-372">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-gold fill-gold" data-id="element-373" />)}
              </div>
              <div className="flex items-baseline gap-1.5 mb-2.5" data-id="element-374">
                <span className="text-white font-bold" data-id="element-375">5.0</span>
                <span className="text-textsecondary text-xs" data-id="element-376">
                  (127 reseñas)
                </span>
              </div>
              <div className="flex flex-wrap gap-1" data-id="element-377">
                <span className="bg-electric/10 text-electric text-[9px] rounded px-1.5 py-0.5 font-semibold" data-id="element-378">
                  Workana
                </span>
                <span className="bg-electric/10 text-electric text-[9px] rounded px-1.5 py-0.5 font-semibold" data-id="element-379">
                  Fiverr
                </span>
                <span className="bg-electric/10 text-electric text-[9px] rounded px-1.5 py-0.5 font-semibold" data-id="element-380">
                  LinkedIn
                </span>
              </div>
            </motion.div>

            {/* Floating CTA pill — neon gold, glowing, polished */}
            <a href="#pricing" className="absolute left-1/2 -translate-x-1/2 -bottom-16 md:-bottom-20 z-40 w-[94%] max-w-md group" data-id="element-381">
              {/* Outer neon glow (static) */}
              <span aria-hidden="true" className="absolute -inset-1 rounded-full bg-gradient-to-r from-electric via-gold to-electric blur-xl opacity-60 group-hover:opacity-90 transition-opacity duration-500" data-id="element-382"></span>

              {/* Button body */}
              <span className="relative flex items-center justify-between gap-3 bg-gradient-to-r from-electric via-gold to-electric text-graphite rounded-full pl-5 pr-2 py-2.5 shadow-[0_0_30px_rgba(245,185,66,0.6)] hover:shadow-[0_0_50px_rgba(255,209,102,0.85)] border border-gold/80 transition-all duration-300 transform group-hover:-translate-y-0.5 overflow-hidden" data-id="element-383">
                {/* Animated sheen sweep */}
                <span aria-hidden="true" className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/50 to-transparent skew-x-12 pointer-events-none" data-id="element-384"></span>

                <span className="relative flex flex-col items-start leading-tight" data-id="element-385">
                  <span className="text-[10px] md:text-xs font-bold uppercase tracking-[0.18em] text-graphite/75" data-id="element-386">
                    Acceso Instantáneo
                  </span>
                  <span className="text-sm md:text-base font-extrabold uppercase tracking-wide whitespace-nowrap" data-id="element-387">
                    Quiero el MEGAPACK ahora
                  </span>
                </span>

                <span className="relative flex-shrink-0 w-11 h-11 md:w-12 md:h-12 rounded-full bg-graphite text-gold flex items-center justify-center transition-transform duration-300 group-hover:translate-x-0.5 shadow-inner ring-2 ring-gold/30" data-id="element-388">
                  <ArrowRight className="w-5 h-5 md:w-6 md:h-6" strokeWidth={3} data-id="element-389" />
                </span>
              </span>
            </a>
          </motion.div>

          {/* Subhead */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-lg md:text-xl text-textsecondary mb-5 mt-24 md:mt-28 max-w-2xl mx-auto" data-id="element-390">
            El sistema N°1 para personas en Argentina que quieren generar
            ingresos en dólares trabajando desde casa.
          </motion.p>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mb-6 text-sm md:text-base font-medium" data-id="element-391">
            <div className="flex items-center gap-2" data-id="element-392">
              <FileText className="w-5 h-5 text-electric" data-id="element-393" />
              <span className="text-[10px]" data-id="element-394">100% PDF</span>
            </div>
            <div className="hidden md:block w-1 h-1 rounded-full bg-textsecondary/50" data-id="element-395"></div>
            <div className="flex items-center gap-2" data-id="element-396">
              <Clock className="w-5 h-5 text-electric" data-id="element-397" />
              <span className="text-[10px]" data-id="element-398">Acceso en 5 min</span>
            </div>
            <div className="hidden md:block w-1 h-1 rounded-full bg-textsecondary/50" data-id="element-399"></div>
            <div className="flex items-center gap-2" data-id="element-400">
              <Award className="w-5 h-5 text-electric" data-id="element-401" />
              <span className="text-[10px]" data-id="element-402">De 0 a Ingresos en USD</span>
            </div>
          </div>

          {/* Trust micro-badges */}
          <div className="flex flex-col items-center gap-4" data-id="element-403">
            <div className="flex flex-wrap items-center justify-center gap-4 text-xs md:text-sm text-textsecondary" data-id="element-404">
              <div className="flex items-center gap-1" data-id="element-405">
                <ShieldCheck className="w-4 h-4" data-id="element-406" /> Garantía 7 días
              </div>
              <div className="flex items-center gap-1" data-id="element-407">
                <Lock className="w-4 h-4" data-id="element-408" /> Pago seguro
              </div>
              <div className="flex items-center gap-1" data-id="element-409">
                <CreditCard className="w-4 h-4" data-id="element-410" /> Mercado Pago
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}